
import CloseIcon from '../icons/CloseIcon.vue';
import TruncateParagraph from '../atom/TruncateParagraph.vue';

export default {
  name: 'UIPostTickerCard',
  components: {
    CloseIcon,
    TruncateParagraph,
  },
  props: {
    ticker: {
      type: Object,
      required: true,
    },
    showRemoveIcon: {
      type: Boolean,
      default: true,
    },
  },
};
